angular.module('app').directive('angucompleteMiniCrudPessoas', function($rootScope, $timeout) {
	return {
		restrict: 'A',		
        require: 'ngModel',        
        controller: function($scope, $element, $http, $timeout, $compile) {
        	
        	if(!$scope.initEditarPessoa){
	            $scope.initEditarPessoa = function(){
	            	var model = $scope.$eval($element.attr('ng-model'));	            		            	

			        angular.element('[ng-controller=pessoasController]').scope().clear();
			        angular.element('[ng-controller=pessoasController]').scope().obterPessoa( angular.isObject(model) ? model.id : model );
			        angular.element('[ng-controller=pessoasController]').scope().setMinicrudModel($element.attr('ng-model'));

			        $scope.modalPessoaLoaded();
			    };
			}

			if(!$scope.initInserirPessoa){
			    $scope.initInserirPessoa = function(tipo){
			        angular.element('[ng-controller=pessoasController]').scope().clear();        
			        
			        if($element.attr('data-grupo-pessoa')=='fornecedor')
			        	angular.element('[ng-controller=pessoasController]').scope().definirFornecedor();
			       	else 
			       	if($element.attr('data-grupo-pessoa')=='cliente')
			        	angular.element('[ng-controller=pessoasController]').scope().definirCliente();
			        
			        angular.element('[ng-controller=pessoasController]').scope().setMinicrudModel($element.attr('ng-model'));

			        $scope.modalPessoaLoaded();
			    };
			}

			if(!$scope.modalPessoaLoaded){				
				$scope.modalPessoaLoaded = function(){   					
			        angular.element('[ng-controller=pessoasController]').scope().voltar = false;			        
			        angular.element('[ng-controller=pessoasController]').scope().validarModal = function(){
			            var ctrl = angular.element('[ng-controller=pessoasController]');            
			            switch($element.attr('data-grupo-pessoa')){
			            	case 'cliente':
			            		if(!ctrl.scope().isCliente()){
					                $.gritter.add({
					                    title: 'Informações inválidas',
					                    text: 'Adicione a pessoa ao grupo de clientes antes de salvar',
					                    time: 3000,
					                    class_name: 'erro'
					                });
					                return false;   
				            	}
			            	break;	
			            	case 'fornecedor':			            	
			            		if(!ctrl.scope().isFornecedor()){
					                $.gritter.add({
					                    title: 'Informações inválidas',
					                    text: 'Adicione a pessoa ao grupo de fornecedores antes de salvar',
					                    time: 3000,
					                    class_name: 'erro'
					                });
					                return false;   
				            	}
			            	break;			            	
			            }

			            return true;
			        };
			    };
			}
        },
        link: function ($scope, $element, attrs, ctrl) {
        	if(!$rootScope.$$listeners['pessoa-salva']){
				$rootScope.$on('pessoa-salva', function(event, pessoa, modelRef){   
					if(modelRef != $element.attr('ng-model'))
						return false;

			        angular.element('#modal_cadastro_pessoas').modal('hide');

			        if(attrs.completeObject=='true'){
				        //forçar para recarregar            
				        if(!ctrl.$modelValue || pessoa.id!=ctrl.$modelValue.id){
				            ctrl.$setViewValue(pessoa);
				        }else
				        if(pessoa.id == ctrl.$modelValue.id){
				            ctrl.$setViewValue({});          
				            $timeout(function(){
				            	ctrl.$setViewValue(pessoa);			                
				            }, .5);
				        }
				    }else{
				    	//forçar para recarregar            
				        if(!ctrl.$modelValue || pessoa.id!=ctrl.$modelValue){
				            ctrl.$setViewValue(pessoa.id);
				        }else
				        if(pessoa.id == ctrl.$modelValue){
				            ctrl.$setViewValue(null);          
				            $timeout(function(){
				            	ctrl.$setViewValue(pessoa.id);			                
				            }, .5);
				        }
				    }
			    });
			}
        }
    };
});